import { InvalidVerificationCode, VerificationCodeHasExpired, InvalidRefreshToken, UserNotFound } from './errorCodes.constants';

export const customError: Record<string, string> = {
  [InvalidVerificationCode]: 'Invalid verification code. Please check the code and try again.',
  [VerificationCodeHasExpired]: 'Verification code has expired. Please send it again.',
  [InvalidRefreshToken]: 'Your session has expired, please login.',
  [UserNotFound]: 'User not found',
};
